import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";

// import JS files
import useFetch from "../../../../context/useFetch";
import TableIconModal from "../../../shares/TableIconModal";

const RemoveOrder = (props) => {
  const [openModal, setOpenModal] = useState(false);

  const createLog = useFetch({
    method: "post",
    url: `Order_Service/${props.selectedRow?.id}/create_order_log`,
    data: { state: "order_cancel" },
    argFunc: (res) => {},
    errMessage: (mess) => {},
  });

  const updateOrderApi = useFetch({
    method: "post",
    url: `ProviderOrder_Service/${props.selectedRow?.id}/cancel_provider_order`,
    trigger: false,
    data: { state: "cancel" },
    argFunc: (res) => {
      // toast.success("سفارش با موفقیت  لغو شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      setOpenModal(false);
      createLog.reFetch();
      props.adminGetProviderCurrentOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const admin_change_order_to_on_cancle = () => {
    updateOrderApi.reFetch();
  };

  return (
    <>
      <TableIconModal
        width="w-2/5"
        isRemove={true}
        removeText="آیا از حذف سفارش اطمینان دارید؟"
        icon={<DeleteIcon />}
        openModal={openModal}
        setOpenModal={setOpenModal}
        handleRemoveOnClick={admin_change_order_to_on_cancle}
      ></TableIconModal>
    </>
  );
};

export default RemoveOrder;
